export default __webpack_public_path__ + "static/media/icon-success.b37d3e4e.png";